import { render, staticRenderFns } from "./entrepreneurship-and-small-business.svg?vue&type=template&id=16f1fa39&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports